module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-8.f1d8ec9b.png";